import { SectionLabel } from "@/components/yanre/SectionLabel";
import { Reveal, RevealLines } from "@/components/yanre/Reveal";
import { useLocale } from "@/i18n/LocaleContext";

// Credibility — ONLY claims verified from the institutional YANRE WEBSITE
// (its trust ticker and sections: Est. 1997 · 200+ Patents · 110+ Countries ·
// CE · TÜV · ISO · 34,950+ Projects).
const PILLARS = [
  { key: "wy.p1", title: "Manufacturing", body: "In-house manufacturing of commercial-grade strength systems — engineered and produced by YANRE, not assembled from third-party designs." },
  { key: "wy.p2", title: "Engineering & Biomechanics", body: "Original design since 1997, with 200+ patents covering equipment engineering and movement biomechanics." },
  { key: "wy.p3", title: "Commercial Durability", body: "Equipment built for professional daily use, certified to CE, TÜV and ISO standards." },
  { key: "wy.p4", title: "Product Development", body: "A manufacturer-led product range — from the 73 Tough Series to plate-loaded lines, dual-function machines and commercial cardio." },
  { key: "wy.p5", title: "International Experience", body: "Trusted by professional gyms in 110+ countries, with 34,950+ gym projects delivered worldwide." },
];

const PROOF = ["Est. 1997", "200+ Patents", "110+ Countries", "CE · TÜV · ISO", "34,950+ Projects"];

export const WhyYanre = ({ index }) => {
  const { t } = useLocale();
  return (
    <section id="why-yanre" className="section-dark relative overflow-hidden border-t border-carbon-700" data-testid="why-yanre-section">
      <div className="grid-lines absolute inset-0 opacity-40" />
      <div className="container-edge relative py-16 lg:py-24">
        <Reveal>
          <SectionLabel index={index}>Why YANRE FITNESS</SectionLabel>
        </Reveal>
        <h2 className="mt-8 max-w-4xl font-display text-4xl font-extrabold uppercase leading-[0.92] tracking-tight text-white sm:text-5xl lg:text-6xl">
          <RevealLines
            lines={[
              t("wy.h1a", "Engineered by experience."),
              <span key="b">
                {t("wy.h1b", "Built for performance.")}
              </span>,
            ]}
          />
        </h2>
        <div className="mt-12 grid gap-x-16 gap-y-8 lg:grid-cols-2" data-testid="why-yanre-pillars">
          {PILLARS.map((p, i) => (
            <Reveal key={p.key} delay={i * 0.05}>
              <div className="border-t border-carbon-700 pt-6">
                <div className="grid grid-cols-[auto_1fr] gap-6">
                  <span className="font-display text-3xl font-extrabold text-white/15">{String(i + 1).padStart(2, "0")}</span>
                  <div>
                    <h3 className="font-display text-lg font-bold uppercase text-white sm:text-xl">{t(`${p.key}.t`, p.title)}</h3>
                    <p className="mt-2 max-w-md text-sm leading-relaxed text-titanium/60 sm:text-base">{t(`${p.key}.b`, p.body)}</p>
                  </div>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
        <Reveal delay={0.15}>
          <div className="mt-12 flex flex-wrap gap-x-10 gap-y-4 border-t border-carbon-700 pt-7" data-testid="why-yanre-proof">
            {PROOF.map((item, i) => (
              <span key={item} className="font-mono text-[11px] uppercase tracking-[0.25em] text-titanium/50">{t(`wy.proof${i}`, item)}</span>
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
};
